import React from 'react';
import PortalApp from './portal/PortalApp';

const App: React.FC = () => {
  return <PortalApp />;
};

export default App;